import { useParams } from "react-router-dom";

const Invoice = () => {
  const { orderId } = useParams();
  return <div>Tracking info for Order {orderId}</div>;
};

export default Invoice;
